import { RowDataStoreItem } from "../../components/StoreItemIncompletePage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the StoreItemIncompleteTable factory
 */
class StoreItemIncompleteRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/items/read-range-incomplete"
        this.accessData = "items"
    }

    create(item: any): RowDataStoreItem {
        const rowDataOrder: RowDataStoreItem = {

            id: item.id,
            displayName: item.displayName,
            itemName: item.itemName,
            altItemLookup: item.altItemLookup,
            xItemId: item.xItemId,
            xItemCode: item.xItemCode, 
            xItemType: item.xItemType, 
            xItemModel: item.xItemModel, 
            xDivision: item.xDivision, 
            brand: item.brand,
            xCategory: item.xCategory, 
            cost: item.cost,
            priceScheme: item.priceScheme ? JSON.parse(item.priceScheme) : null,
            description: item.description, 
            images: item.images,
            show: item.show, 
            isReady: item.isReady,
            deleted: item.deleted,
            createdAt: item.createdAt, 
            updatedAt: item.updatedAt,
            category: item.category,

            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let storeItemIncompleteRow: StoreItemIncompleteRow | null = null;

export default function getStoreItemIncompleteRow(): StoreItemIncompleteRow {
    if (storeItemIncompleteRow === null)
        storeItemIncompleteRow = new StoreItemIncompleteRow()
    return storeItemIncompleteRow
}